import {
    GoogleAuthProvider,
    signInWithPopup,
    signOut,
    onAuthStateChanged,
    Unsubscribe
} from 'firebase/auth';
import { auth } from './firebase.js';

// We'll store the user object in localStorage under this key
const LOCAL_STORAGE_KEY = 'firebase_user';

/**
 * A helper method to watch Firebase auth changes.
 * This can help keep localStorage in sync if the user logs out in another tab, etc.
 * You can call it once at app startup.
 */
let firebaseAuthUnsubscribe: Unsubscribe | null = null;
const watchFirebaseAuth = () => {
    if (firebaseAuthUnsubscribe) return; // Only subscribe once

    firebaseAuthUnsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {
            localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(user));
        } else {
            localStorage.removeItem(LOCAL_STORAGE_KEY);
        }
    });
};

watchFirebaseAuth(); 

/**
 * React Admin AuthProvider using Firebase
 */
const authProvider = {
    login: async () => {
        try {

            const provider = new GoogleAuthProvider();
            const result = await signInWithPopup(auth, provider);
            const user = result.user;

            localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(user));

            return Promise.resolve(); 
        } catch (error) {
            console.error('Firebase login error:', error);
            return Promise.reject(error);
        }
    },


    logout: async () => {
        try {
            await signOut(auth);
        } catch (error) {
            console.error('Firebase sign-out error:', error);
        }

        localStorage.removeItem(LOCAL_STORAGE_KEY);
        return Promise.resolve();
    },

    // Called when the API returns an error (e.g. 401 or 403)
    // For Firebase, you can usually just resolve. If you have custom error handling, do it here.
    checkError: () => Promise.resolve(),

    // Called before each data call to verify the user is still logged in.
    checkAuth: () => {
        const user = localStorage.getItem(LOCAL_STORAGE_KEY);
        return user ? Promise.resolve() : Promise.reject();
    },

    // If you need role-based access, read claims from the user object.
    // Return different permissions based on custom claims or additional data.
    getPermissions: async () => {
        // Example: If you store custom claims in user, parse them here.
        return Promise.resolve({});
    },

    // Used by React Admin to display user info (e.g. top right corner with avatar)
    getIdentity: async () => {
        const storedUser = localStorage.getItem(LOCAL_STORAGE_KEY);
        if (!storedUser) {
            return Promise.reject('No user');
        }
        const user = JSON.parse(storedUser);

        // React Admin expects an object with at least an "id"
        // You can also include "fullName" and "avatar"
        return Promise.resolve({
            id: user.uid,
            fullName: user.displayName,
            avatar: user.photoURL,
        });
    },
};

export default authProvider;
